import { ErrorUiType, IAPIResponseError, IError } from '@checkout/errors';
import { IUnavailableItem } from '@checkout/state';
import { AxiosResponse } from 'axios';
import { IntlProvider } from 'react-intl';
import intlMessages from './../i18n/base-en';

interface IConvertAPIErrorsParams {
  apiResponse: IAPIResponseError;
  intl: ReactIntl.InjectedIntl;
  unavailable?: IUnavailableItem[];
  uiType?: ErrorUiType;
}

const convertAPIErrors = ({ apiResponse, intl, uiType }: IConvertAPIErrorsParams): IError => {
  const apiErrors = apiResponse.errors;
  const unavailable = apiResponse.unavailable;
  let errorsArray: any = [];
  const { formatMessage } = intl;
  const convertedMessages: IError = {
    error: false,
    details: undefined,
    code: '',
    config: {},
    messages: [],
    name: '',
    title: '',
    message: '',
    response: {} as AxiosResponse<IAPIResponseError>,
    uiType: uiType ? uiType : 'overlay',
  };
  convertedMessages.messages = [];

  if (apiErrors && apiErrors instanceof Array) {
    errorsArray = apiErrors;
  } else if (apiErrors instanceof Object) {
    errorsArray.push(apiErrors);
  }

  const defaultMessageCode = '#0001';
  const defaultMessage = formatMessage(intlMessages.default_error_message);

  if (errorsArray) {
    if (apiResponse && apiResponse.messages && apiResponse.messages.length > 0) {
      convertedMessages.messages = apiResponse.messages;
    }

    errorsArray.map((errors: {}) => {
      Object.keys(errors).map(prop => {
        switch (prop) {
          case 'stock':
            if (errors[prop] === 'unavailable items') {
              convertedMessages.title = formatMessage(intlMessages.unavailable_items);
              convertedMessages.code = intlMessages.unavailable_items.id;

              // Unavailable items
              if (unavailable && unavailable.length > 0) {
                unavailable.map(item => {
                  convertedMessages.messages.push(
                    formatMessage(intlMessages.unavailable_items_info, {
                      quantity: item.unavailable,
                      product: item.product.name
                    })
                  );
                });
              }
            } else {
              convertedMessages.code = defaultMessageCode;
              convertedMessages.messages.push(`${prop}: "${errors[prop]}"`);
              convertedMessages.messages.push(formatMessage(intlMessages.default_error_message));
            }
            break;
          case 'selection':
            if (errors[prop] === 'no items in selection') {
              break; // Handling this defferent way (showing EmptyBagInfo component)
            } else if (errors[prop] === 'not found' || errors[prop] === 'selection not found') {
              convertedMessages.code = intlMessages.selection_not_found.id;
              convertedMessages.messages.push(formatMessage(intlMessages.selection_not_found));
            } else {
              convertedMessages.code = defaultMessageCode;
              convertedMessages.messages.push(`${prop}: "${errors[prop]}"`);
              convertedMessages.messages.push(formatMessage(intlMessages.default_error_message));
            }
            break;
          case 'item':
            if (errors[prop] === 'product item not found') {
              convertedMessages.code = intlMessages.product_not_found.id;
              convertedMessages.messages.push(formatMessage(intlMessages.product_not_found));
            } else {
              convertedMessages.code = defaultMessageCode;
              convertedMessages.messages.push(`${prop}: "${errors[prop]}"`);
              convertedMessages.messages.push(formatMessage(intlMessages.default_error_message));
            }
            break;
          case 'voucher':
            if (errors[prop] === 'not found') {
              convertedMessages.code = intlMessages.voucher_not_found.id;
              convertedMessages.messages.push(formatMessage(intlMessages.voucher_not_found));
            } else {
              convertedMessages.code = defaultMessageCode;
              convertedMessages.messages.push(`${prop}: "${errors[prop]}"`);
              convertedMessages.messages.push(formatMessage(intlMessages.default_error_message));
            }
            break;
          case 'paymentMethod':
            if (errors[prop] === 'failed') {
              convertedMessages.code = intlMessages.payment_method_failed.id;
              convertedMessages.messages.push(formatMessage(intlMessages.payment_method_failed));
            } else if (errors[prop] === 'COUNTRY_MISMATCH') {
              convertedMessages.code = intlMessages.country_mismatch.id;
              convertedMessages.messages.push(formatMessage(intlMessages.country_mismatch));
            } else {
              convertedMessages.code = defaultMessageCode;
              convertedMessages.messages.push(`${prop}: "${errors[prop]}"`);
              convertedMessages.messages.push(formatMessage(intlMessages.default_error_message));
            }
            break;
          case 'email':
            if (errors[prop] === 'already registered') {
              convertedMessages.code = intlMessages.membership_register_error_email.id;
              convertedMessages.messages.push(formatMessage(intlMessages.membership_register_error_email));
            } else if (errors[prop] === 'customer not found') {
              convertedMessages.code = intlMessages.customer_not_fount.id;
              convertedMessages.messages.push(formatMessage(intlMessages.customer_not_fount));
            } else {
              convertedMessages.code = defaultMessageCode;
              convertedMessages.messages.push(`${prop}: "${errors[prop]}"`);
              convertedMessages.messages.push(formatMessage(intlMessages.default_error_message));
            }
            break;
          case 'address.email':
            if (errors[prop] === 'customer not found') {
              convertedMessages.code = intlMessages.customer_not_fount.id;
              convertedMessages.messages.push(formatMessage(intlMessages.customer_not_fount));
            } else if (errors[prop] === 'required') {
              convertedMessages.code = intlMessages.email_required_message.id;
              convertedMessages.messages.push(formatMessage(intlMessages.email_required_message));
            } else {
              convertedMessages.code = defaultMessageCode;
              convertedMessages.messages.push(`${prop}: "${errors[prop]}"`);
              convertedMessages.messages.push(formatMessage(intlMessages.default_error_message));
            }
            break;
          case 'password':
            if (errors[prop] === 'incorrect') {
              convertedMessages.code = intlMessages.membership_login_error_password.id;
              convertedMessages.messages.push(formatMessage(intlMessages.membership_login_error_password));
            } else {
              convertedMessages.code = defaultMessageCode;
              convertedMessages.messages.push(`${prop}: "${errors[prop]}"`);
              convertedMessages.messages.push(formatMessage(intlMessages.default_error_message));
            }
            break;
          case 'identityNumber':
            if (errors[prop] === 'not found') {
              convertedMessages.code = intlMessages.pin_not_found_error_message.id;
              convertedMessages.messages.push(formatMessage(intlMessages.pin_not_found_error_message));
            } else {
              convertedMessages.code = defaultMessageCode;
              convertedMessages.messages.push(`${prop}: "${errors[prop]}"`);
              convertedMessages.messages.push(formatMessage(intlMessages.default_error_message));
            }
            break;
          case 'newsletter':
            if (errors[prop] === 'unknown') {
              convertedMessages.code = defaultMessageCode;
              convertedMessages.messages.push(`${prop}: "${errors[prop]}"`);
              convertedMessages.messages.push(formatMessage(intlMessages.default_error_message));
            }
            break;
          case 'i':
            if (errors[prop] === 'not valid' || errors[prop] === 'required') {
              convertedMessages.code = intlMessages.membership_password_reset_link_expire_error.id;
              convertedMessages.messages.push(formatMessage(intlMessages.membership_password_reset_link_expire_error));
            }
            break;
          case 'other':
            if (errors[prop] instanceof Object) {
              const otherError = Object.keys(errors[prop])
                .map(error => `${error}: ${errors[prop][error]}`)
                .join(', ');
              convertedMessages.code = intlMessages.membership_register_error_other.id;
              convertedMessages.messages.push(otherError);
            } else {
              convertedMessages.code = defaultMessageCode;
              convertedMessages.messages.push(`${prop}: "${errors[prop]}"`);
              convertedMessages.messages.push(formatMessage(intlMessages.default_error_message));
            }
            break;
          /* case 'address.state':
          case 'shippingAddress.state':
            if (errors[prop] === 'state not found') {
              convertedMessages.code = intlMessages.state_not_found.id;
              convertedMessages.messages.push(formatMessage(intlMessages.state_not_found, { addressField: prop }));
            }
            break; */
          default:
            convertedMessages.code = defaultMessageCode;
            convertedMessages.messages.push(`${prop}: "${errors[prop]}"`);
            convertedMessages.messages.push(defaultMessage);
        }
      });
    });
  }

  return convertedMessages;
};

const convertMessages = (data: IAPIResponseError, intlData: IntlProvider.Props, uiType?: ErrorUiType): IError => {
  const { intl } = new IntlProvider({ ...intlData }, {}).getChildContext();

  // if (data.errors && data.errors instanceof Array) {
  return convertAPIErrors({ apiResponse: data, intl, uiType });
};

export default convertMessages;
